/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { GmcError } from '@app/core/types';
import { createAction, props } from '@ngrx/store';
import { CreateTeamRequestBody, Team, TeamId } from '@shared/types/team';

export const teamSelect = createAction('[Teams] Team select', props<{ teamId: TeamId }>());
export const renameTeamIntent = createAction('[Teams] Rename team intent', props<{ teamId: TeamId }>());
export const renameTeam = createAction('[Teams] Rename team', props<{ teamId: TeamId; name: string }>());
export const renameTeamOk = createAction(
  '[Teams] Rename team OK',
  props<{ teamId: TeamId; name: string; notification?: string }>(),
);
export const renameTeamErr = createAction(
  '[Teams] Rename team Err',
  props<GmcError & { teamId: TeamId; name: string }>(),
);
export const removeTeamIntent = createAction('[Teams] Remove team intent', props<{ teamId: TeamId }>());
export const removeTeam = createAction('[Teams] Remove team', props<{ teamId: TeamId }>());
export const removeTeamOk = createAction('[Teams] Remove team OK', props<{ teamId: TeamId; notification?: string }>());
export const removeTeamErr = createAction('[Teams] Remove team Err', props<GmcError & { teamId: TeamId }>());
export const leaveTeam = createAction('[Teams] Leave team', props<{ teamId: TeamId }>());
export const leaveTeamOk = createAction('[Teams] Leave team OK', props<{ teamId: TeamId; notification?: string }>());
export const leaveTeamErr = createAction('[Teams] Leave team Err', props<GmcError & { teamId: TeamId }>());
export const grantAdministratorRole = createAction(
  '[Teams] Grant administrator role',
  props<{ teamId: TeamId; email: string }>(),
);
export const grantAdministratorRoleOk = createAction(
  '[Teams] Grant administrator role OK',
  props<{ teamId: TeamId; email: string; notification?: string }>(),
);
export const grantAdministratorRoleErr = createAction(
  '[Teams] Grant administrator role Err',
  props<GmcError & { teamId: TeamId; email: string }>(),
);
export const revokeAdministratorRole = createAction(
  '[Teams] Revoke administrator role',
  props<{ teamId: TeamId; email: string }>(),
);
export const revokeAdministratorRoleOk = createAction(
  '[Teams] Revoke administrator role OK',
  props<{ teamId: TeamId; email: string; notification?: string }>(),
);
export const revokeAdministratorRoleErr = createAction(
  '[Teams] Revoke administrator role Err',
  props<GmcError & { teamId: TeamId; email: string }>(),
);
export const kickFromTeam = createAction('[Teams] Kick from team', props<{ teamId: TeamId; email: string }>());
export const kickFromTeamOk = createAction(
  '[Teams] Kick from team OK',
  props<{ teamId: TeamId; email: string; notification?: string }>(),
);
export const kickFromTeamErr = createAction(
  '[Teams] Kick from team err',
  props<GmcError & { teamId: TeamId; email: string }>(),
);
export const addTeamIntent = createAction('[Teams] Add team intent');
export const addTeam = createAction('[Teams] Add team', props<{ params: CreateTeamRequestBody }>());
export const addTeamOk = createAction('[Teams] Add team OK', props<{ team: Team; notification?: string }>());
export const addTeamErr = createAction('[Teams] Add team Err', props<GmcError & { params: CreateTeamRequestBody }>());

export const inviteUsers = createAction('[Teams] Invite Users', props<{ teamId: TeamId; emails: string[] }>());
export const inviteUsersOK = createAction(
  '[Teams] Invite Users OK',
  props<{ teamId: TeamId; emails: string[]; notification?: string }>(),
);
export const inviteUsersErr = createAction(
  '[Teams] Invite Users err',
  props<GmcError & { teamId: TeamId; emails: string[] }>(),
);
export const inviteUsersValidationErr = createAction('[Teams] Invite Users Validation err', props<GmcError>());
